import { type CompanyData, type CompanyGetInput, type CompanyGetSuccess, DAY, HOUR, isNotEmpty } from '@terros/common'
import { useProfile } from '../user'
import { useTantalimQuery } from '../query'
import { companyKey } from '../keys'
import { type GetHookResponse } from '../hooks'

export function useCompany(inputOriginal: CompanyGetInput = {}, enabled = true): GetHookResponse<CompanyData> {
  const { user } = useProfile()

  const input: CompanyGetInput = {
    ...inputOriginal,
    companyId: inputOriginal.companyId ?? user?.companyId,
  }

  return useTantalimQuery<CompanyGetInput, CompanyGetSuccess, CompanyData>({
    url: '/company/get',
    queryKey: companyKey(input.companyId),
    input,
    convertResponse: (data) => data.company,
    options: {
      enabled: enabled && isNotEmpty(input.companyId),
      gcTime: DAY,
      staleTime: HOUR,
    },
  })
}
